import type { FeatureFlags } from '@features/flags.graphql'

/**
 * A mock implementation of the FeatureFlags interface.
 * This mock is intended for local development and testing purposes only.
 * This is your own local configuration of the feature flags.
 * You can use this to set up your own feature flags for local development and testing.
 */
export const LocalFeatureFlagsMock: Partial<FeatureFlags> = {}
